// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.featured--related {
  position: relative;
}

/* ## NSW Card Overrides */

.search--featured .nsw-card__content {
  border-top-color: #47888E;
  padding-bottom: 0;
  padding-top: 0;
}

.search--featured .nsw-card__title {
  padding-top: 0;
}

.search--featured .nsw-card__content .nsw-card__link {
  color: black;
  font-size: 1rem;
}

.search--featured .nsw-card {
  height: -moz-fit-content;
  height: fit-content;
  margin-bottom: 24px;
  max-width: 100%;
}

  .search--featured .nsw-card:last-child {
    margin-bottom: 0;
  }

.search--featured .nsw-card__content {
  position: relative;
}

.search--featured .nsw-card__copy {
  font-size: 14px;
}

/* Overflow handling */
.search--featured .nsw-card__copy {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.featured--related {
  position: relative;
  order: 4;
  padding: 0 32px 16px 16px;
  transition: box-shadow .25s ease-in-out;
}

  .featured--related:hover {
    box-shadow: 2px 6px 12px 0 rgba(0,0,0,.25);
    transition: box-shadow .25s ease-in-out;
  }

  .featured--related .nsw-card__icon {
    right: 16px;
  }

@media (min-width: 768px) {
  .featured--related {
    padding: 0 64px 32px 32px;
  }

    .featured--related .nsw-card__icon {
      right: 32px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/uilib/featured-cards/featuredcards.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;;AAE1B;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;EAEE;IACE,gBAAgB;EAClB;;AAEF;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,uCAAuC;AACzC;;EAEE;IACE,0CAA0C;IAC1C,uCAAuC;EACzC;;EAEA;IACE,WAAW;EACb;;AAEF;EACE;IACE,yBAAyB;EAC3B;;IAEE;MACE,WAAW;IACb;AACJ","sourcesContent":[".featured--related {\r\n  position: relative;\r\n}\r\n\r\n/* ## NSW Card Overrides */\r\n\r\n.search--featured .nsw-card__content {\r\n  border-top-color: #47888E;\r\n  padding-bottom: 0;\r\n  padding-top: 0;\r\n}\r\n\r\n.search--featured .nsw-card__title {\r\n  padding-top: 0;\r\n}\r\n\r\n.search--featured .nsw-card__content .nsw-card__link {\r\n  color: black;\r\n  font-size: 1rem;\r\n}\r\n\r\n.search--featured .nsw-card {\r\n  height: fit-content;\r\n  margin-bottom: 24px;\r\n  max-width: 100%;\r\n}\r\n\r\n  .search--featured .nsw-card:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n.search--featured .nsw-card__content {\r\n  position: relative;\r\n}\r\n\r\n.search--featured .nsw-card__copy {\r\n  font-size: 14px;\r\n}\r\n\r\n/* Overflow handling */\r\n.search--featured .nsw-card__copy {\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 3;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.featured--related {\r\n  position: relative;\r\n  order: 4;\r\n  padding: 0 32px 16px 16px;\r\n  transition: box-shadow .25s ease-in-out;\r\n}\r\n\r\n  .featured--related:hover {\r\n    box-shadow: 2px 6px 12px 0 rgba(0,0,0,.25);\r\n    transition: box-shadow .25s ease-in-out;\r\n  }\r\n\r\n  .featured--related .nsw-card__icon {\r\n    right: 16px;\r\n  }\r\n\r\n@media (min-width: 768px) {\r\n  .featured--related {\r\n    padding: 0 64px 32px 32px;\r\n  }\r\n\r\n    .featured--related .nsw-card__icon {\r\n      right: 32px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
